import { push }             from "connected-react-router";
import {
  useDispatch,
  useSelector
}                           from "react-redux";
import service              from "../services";
import { ApplicationState } from "../store";
import {
  authReset,
  authSuccess,
  setServiceType
}                           from "../store/API/actions";
import { APIState }         from "../store/API/types";
import { chooseService }   from "../utils";
import { serviceTypeEnum } from '../store/API/types';
import useLocalStorage     from "./useLocalStorage";


const useCheckSession = () => {
  const dispatch = useDispatch();
  const {token, token2} = useSelector<ApplicationState, APIState>(state => state.API);
  const serviceType = window.CONFIG.ServerType;

  const setLSToken = (token: string, token2?: string) => {
    const username = localStorage.getItem('username');
    dispatch(authSuccess(username ? username : '', token, token2));
  };
  const resetLSToken = () => {
    window.localStorage.removeItem('token');
    window.localStorage.removeItem('token2');
    dispatch(authReset())
  };

  const checkConnection = (token: string, token2?: string) => {
    dispatch(setServiceType(serviceType));

    switch (serviceType) {
      case serviceTypeEnum.ocularis:
        service.checkConnection(token)
          .then(() => {
            setLSToken(token, token2)
          })
          .catch(() => {
            resetLSToken()
          });
        break;
      case serviceTypeEnum.cayuga:
        service.checkConnection(token)
          .then((res: any) => {
            if (res.error) {
              resetLSToken()
            } else {
              setLSToken(token)
            }
          });
        break;
      default:
        break;
    }
  };

  useLocalStorage(['token', 'token2'], checkConnection, () => dispatch(push('/auth')));
  return typeof token === 'string' && (chooseService(() => token2 && token2 !== '', () => true))
};

export default useCheckSession